<div class="spinner-wrapper" *ngIf="requestProcessing">
    <div class="spinner">
        <div class="inner">
            <div class="gap"></div>
            <div class="left">
                <div class="half-circle"></div>
            </div>
            <div class="right">
                <div class="half-circle"></div>
            </div>
        </div>
    </div>
</div>
<div id="home-2" class="page-layout simple">
    <div class="content p-4">
        <div fxLayout="column" fxLayoutAlign="center">
            <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
                <div class="course" fxFlex="100" [ngClass]="'web'" [@animate]="{value:'*',params:{y:'100%'}}">
                    <mat-expansion-panel [expanded]="true"  class="course-content" fxLayout="column" fxFlex="1 1 auto">

                        <mat-expansion-panel-header class="header" fxLayout="row" fxLayoutAlign="center center"
                             [ngClass]="'web-bg'">
                            <div class="length" fxLayout="row" fxLayoutAlign="center center">
                                <mat-icon class="length-icon s-20">search</mat-icon>
                                <div class="min">Search</div>
                            </div>
                        </mat-expansion-panel-header>
                        <home-2-search 
                            [seaport]="seaport" 
                            [country]="country" 
                            [unitType]="unitType"
                            (polpoint)="setPol($event)"
                            (podpoint)="setPod($event)"
                            (submitItem)="onSearchSubmit($event)"
                            >
                              
                        </home-2-search>
                    </mat-expansion-panel>

                </div>
                <!--
                <div class="course" fxFlex="100" [ngClass]="'web'" [@animate]="{value:'*',params:{y:'100%'}}" *ngIf="doSearch">
                    <mat-expansion-panel [expanded]="true"  class="course-content" fxLayout="column" fxFlex="1 1 auto">

                        <mat-expansion-panel-header class="header" fxLayout="row" fxLayoutAlign="center center"
                             [ngClass]="'web-bg'">
                            <div class="length" fxLayout="row" fxLayoutAlign="center center">
                                <mat-icon class="length-icon s-20">report</mat-icon>
                                <div class="min">Sailing Schedule from {{pol.name}} to {{pod.name}}</div>
                            </div>
                        </mat-expansion-panel-header>
                        <home-result *ngIf="resultLength > 0"></home-result>
                    </mat-expansion-panel>

                </div>
                -->
                <div id="map" class="course" fxFlex="100" [ngClass]="'web'" [@animate]="{value:'*',params:{y:'100%'}}" >
                    <mat-expansion-panel [expanded]="true"  class="course-content" fxLayout="column" fxFlex="1 1 auto">

                        <mat-expansion-panel-header class="header" fxLayout="row" fxLayoutAlign="center center"
                             [ngClass]="'web-bg'">
                            <div class="length mr-16" fxLayout="row" fxLayoutAlign="center center">
                                <mat-icon class="length-icon s-20">map</mat-icon>
                                <div class="min">Port to Port Map</div>
                            </div>
                        </mat-expansion-panel-header>
                        <!--
                        <home-map></home-map>
                    -->
                        <agm-map class="h-640 w-100-p"
                            [minZoom]="1"
                            [maxZoom]="20"
                            [fullscreenControl]="false"
                            [rotateControl]="false"
                            [zoomControl]="true"
                            [scaleControl]="true"
                            [streetViewControl]="false"
                            [scrollwheel]="false"
                            [zoom]="6"
                            [usePanning]="true"
                            [latitude]="x" 
                            [longitude]="y"
                            #AgmMap
                            >
                              <agm-marker *ngIf="pol"
                              [latitude]="pol.info.coords.lat"
                              [longitude]="pol.info.coords.lng">

                                <agm-info-window>
                                  <strong>{{pol.name}}</strong>
                                </agm-info-window>

                              </agm-marker>
                              <agm-marker *ngIf="pod"
                              [latitude]="pod.info.coords.lat"
                              [longitude]="pod.info.coords.lng">

                                <agm-info-window>
                                  <strong>{{pod.name}}</strong>
                                </agm-info-window>

                              </agm-marker>
                              <ng-container>
                                 <agm-polyline [strokeColor]="'red'" [editable]='true'>
                                  <agm-polyline-point *ngFor="let point of polyline" [latitude]="point.lat" [longitude]="point.lng">
                                  </agm-polyline-point>
                                </agm-polyline>
                              </ng-container>
                        </agm-map>
                    </mat-expansion-panel>

                </div>
            </div>

        </div>

    </div>
    <!-- / CONTENT -->
    <div class="content" *ngIf="name != 'Guest'">
        <div fxLayout="column" fxLayoutAlign="center">
            <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
                <div class="course" *ngFor="let item of shortcut" fxFlex="100" fxFlex.gt-xs="50"
                     fxFlex.gt-md="33" [ngClass]="'web'" [@animate]="{value:'*',params:{y:'100%'}}">

                    <div class="course-content" fxLayout="column" fxFlex="1 1 auto">

                        <div class="header-item" fxLayout="row" fxLayoutAlign="center center"
                             [ngClass]="'web-bg'">

                            <div class="category" fxFlex>
                                {{item[0].pol.name}} to {{item[0].pod.name}}
                            </div>
                        </div>
                        <!--
                        <div class="content" [ngStyle]="{'background-image': 'url(' + item.image + ')', 'background-repeat': 'no-repeat', 'background-size': 'cover', 'background-position': 'center'}"
                            fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                        -->
                        <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                            <div *ngFor="let fcl of item; let i = index">
                                <div *ngIf="i<3">
                                    <span class="updated">OCEAN FREIGHT </span>
                                    <span class="h1" style="color: blue">{{fcl.amount | number:(fcl.currency.code == 'VND' ? '1.0-0' : '1.2-2')}} {{fcl.currency.code}} </span>
                                    <span class="updated">per {{fcl.unit.code}}</span>
                                </div>
                            </div>
                            <div class="updated mt-8">Validity: {{item[0].validity | date: 'MM/dd/yyyy'}}</div>
                        </div>

                        <div class="footer" fxLayout="row" fxLayoutAlign="end center">
                            <button mat-button color="accent" (click)="getResultByShortcut(item)">
                                Direct service
                            </button>
                        </div>

                    </div>

                </div>
                    <!--
                    <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                        <div class="header" fxLayout="row" fxLayoutAlign="center center"
                             [ngClass]="course.category + '-bg'">

                            <div class="category" fxFlex>
                                HAIPHONG to HONGKONG
                            </div>

                            <div class="length" fxLayout="row" fxLayoutAlign="center center">
                                <mat-icon class="length-icon s-20">access_time</mat-icon>
                                <div class="min">20 min</div>
                            </div>

                        </div>

                        <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                            <img src="assets/images/cards/card1.jpg">
                            <div class="h1">Validity: 01/31/2019</div>
                            <div class="updated">Direct</div>
                            <div class="updated">Unit support: 20DC/40HC</div>
                        </div>

                        <div class="footer" fxLayout="row" fxLayoutAlign="end center">
                            <button mat-button color="accent"
                                    [routerLink]="'/apps/academy/courses/' + course.id + '/' + course.slug">
                                View
                            </button>
                        </div>

                    </div>
                    -->
            </div>
        </div>
    </div>
</div>
